import ErrorBoundary from "components/ErrorBoundary";
import LoadingWrapper from "./LoadingWrapper";
import PropTypes from 'prop-types';



const Wrapper = ({ isLoading, error = null, children = null, className = '' }) => {

    return (
        <div className={`relative ${className || ''}`}>
            {isLoading &&
                <div className="h-auto w-auto">
                    <LoadingWrapper isLoading={isLoading} />
                </div>
            }
            {!isLoading && !!error && <ErrorBoundary  className="w-auto" error={error} />}
            {!isLoading && !error && children}
        </div>

    );
}

Wrapper.propTypes = {
  isLoading: PropTypes.bool,
  error: PropTypes.any,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Wrapper;